<template>
	<div style="width: 50%;margin-top: 30px;">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>添加分销商</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form style="margin-top: 2.5rem" label-width="140px" :model="distributorParam" ref="distributorForm">
		  <el-form-item label="分销商名称" prop="distributorName">
			<el-input size="small" v-model="distributorParam.distributorName" auto-complete="off" placeholder="请输入部门名称"></el-input>
		  </el-form-item>
		  <el-form-item label="公司全名" prop="companyName">
			<el-input size="small" v-model="distributorParam.companyName" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="联系人" prop="linkman">
			<el-input size="small" v-model="distributorParam.linkman" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="联系电话" prop="phone">
			<el-input size="small" v-model="distributorParam.phone" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="押金" prop="antecedentMoney">
			<el-input size="small" v-model="distributorParam.antecedentMoney" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="合同" prop="contractUrl">
			<el-upload
			  class="upload-demo"
			  :action="uploadImgUrl"
			  :limit="1"
			  :file-list="contractFileList"
			  :on-success="contractUploadCallback"
			  list-type="picture">
			  <el-button size="small" type="primary">点击上传</el-button>
			  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
			</el-upload>
		  </el-form-item>
		  <el-form-item label="营业执照" prop="businessLicense">
				<el-upload
				  class="upload-demo"
				  :file-list="licenseFileList"
				  :action="uploadImgUrl"
				  :on-success="licenseUploadCallback"
				  :limit="1"
				  list-type="picture">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
				</el-upload>
		  </el-form-item>
		  <el-form-item label="开户行" prop="bankAddress">
				<el-input size="small" v-model="distributorParam.bankAddress" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="银行账号" prop="bankCardNum">
				<el-input size="small" v-model="distributorParam.bankCardNum" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="社会统一信用代码" prop="creditCode">
				<el-input size="small" v-model="distributorParam.creditCode" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="备注" prop="note">
				<el-input size="small" v-model="distributorParam.note" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="主管理员账号" prop="adminName">
				<el-input size="small" v-model="distributorParam.adminName" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		  <el-form-item label="主管理员密码" prop="adminPwd">
				<el-input size="small" type="password" v-model="distributorParam.adminPwd" auto-complete="off" placeholder="请输入部门代码"></el-input>
		  </el-form-item>
		</el-form>
		<div slot="footer" style="align-items: center;" class="dialog-footer">
		  <el-button size="small">取消</el-button>
		  <el-button size="small" type="primary" class="title" @click="saveDistributor()">保存</el-button>
		</div>
	</div>

</template>

<script>
	
import {uploadSso} from "../../api/common.js"
import {saveDistributorApi} from "../../api/distributor/distributorApi.js"
	
export default {
	data() {
		return {
			uploadImgUrl: "http://dev-api.cloudjoys.com/openapi/uploadFile",
			distributorParam: {
				distributorName: '',
				companyName: '',
				linkman: '',
				phone: '',
				contractUrl: '',
				businessLicense: '',
				bankAddress: '',
				bankCard: '',
				creditCode: '',
				note: '',
			},
			contractFileList: [],
			licenseFileList:[],
			contractFilePath:'',
			licenseFilePath:''
		}
	},
	methods: {
		saveDistributor(){
			let reqParam = {
				distributorName: this.distributorParam.distributorName,
				companyName: this.distributorParam.companyName,
				linkman: this.distributorParam.linkman,
				phone: this.distributorParam.phone,
				antecedentMoney: this.distributorParam.antecedentMoney,
				bankAddress: this.distributorParam.bankAddress,
				bankCardNum: this.distributorParam.bankCardNum,
				creditCode: this.distributorParam.creditCode,
				note: this.distributorParam.note,
				adminName: this.distributorParam.adminName,
				adminPwd: this.distributorParam.adminPwd,
				contractUrl: this.contractFilePath,
				businessLicense: this.licenseFilePath
			}
			saveDistributorApi(reqParam).then(ret=>{
				if(ret.data.code == '000000'){
					this.$router.push({
						path: "distributorlist"
					})
				}
			})
		},
		
		contractUploadCallback (res,file){
			if(res.code == 200){
				this.contractFilePath = res.data.img;
				console.log("upload file :" + this.contractFilePath)
			}
		},
		licenseUploadCallback (res,file){
			if(res.code == 200){
				this.licenseFilePath = res.data.img;
				console.log("upload file :" + this.licenseFilePath)
			}
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/distributor/distributorAdd.vue